import React, { createContext, useContext, useEffect, useState } from "react";
import { doc, collection, onSnapshot, updateDoc, query, where, Query } from "firebase/firestore";
import { db, storage, functions } from "./firebaseConfig";

export interface KioskType {
    id: string;
    docId: string;
    status: "PENDING" | "ACTIVE" | "INACTIVE" | "FULL";
    name?: string;
    address?: string;
    lat?: number;
    lng?: number;
    maxCapacity?: number;
    currentCapacity?: number;
    message?: string;
    photo?: string;
    timestamp?: number;
    partnerId?: string;

    pointPerPet?: number;
}

interface KioskContextType {
    kiosks: KioskType[];
    pendings: KioskType[];
}

const KioskContext = createContext<KioskContextType | null>(null);

export const KioskProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    const partnerId = sessionStorage.getItem("partnerId");

    const [kiosks, setKiosks] = useState<KioskType[]>([]);
    const [pendings, setPendings] = useState<KioskType[]>([]);

    useEffect(() => {
        if (!partnerId) return; // partnerId가 없으면 데이터 조회하지 않음

        const unsubscribe = onSnapshot(
            query(collection(db, "kiosk"), where("status", "==", "PENDING"), where("partnerId", "==", partnerId)),
            (snapshot) => {
                const kioskLists = snapshot.docs
                    .map((doc) => doc.data() as KioskType)
                    .sort((a, b) => {
                        if (a.timestamp && b.timestamp) return a.timestamp - b.timestamp;
                        else return 0;
                    });
                setPendings(kioskLists);
            }
        );
        return () => unsubscribe();
    }, [partnerId]); // partnerId 의존성 추가

    useEffect(() => {
        if (!partnerId) return; // partnerId가 없으면 데이터 조회하지 않음

        const unsubscribe = onSnapshot(
            query(collection(db, "kiosk"), where("status", "!=", "PENDING"), where("partnerId", "==", partnerId)),
            (snapshot) => {
                const kioskLists = snapshot.docs
                    .map((doc) => doc.data() as KioskType)
                    .sort((a, b) => {
                        if (a.timestamp && b.timestamp) return a.timestamp - b.timestamp;
                        else return 0;
                    });
                setKiosks(kioskLists);
            }
        );
        return () => unsubscribe();
    }, [partnerId]); // partnerId 의존성 추가

    return (
        <KioskContext.Provider
            value={{
                kiosks,
                pendings,
            }}
        >
            {children}
        </KioskContext.Provider>
    );
};

export const useKiosk = (): KioskContextType => {
    const context = useContext(KioskContext);
    if (!context) {
        throw new Error("useKiosk must be used within an KioskProvider");
    }
    return context;
};
